import { Injectable, inject } from "@angular/core";
import { NFTService, NFTv2Service } from "../contract/contracts-services/nft.service";
import { TokenService } from "../contract/contracts-services/token.service";
import { UserItemsService } from "../user-items/user-items.service";
import { KryptomonsService } from "../kryptomons/kryptomons.service";
import { Web3Service } from "../web3/web3.service";
import { UserService } from "../user/user.service";
import { ICreateAccount, ISignInResponse } from "./auth.interface";
import { forkJoin, of } from "rxjs";
import { StakingRewardsService } from "../contract/contracts-services/staking-rewards.service";
import { PlaydexService } from "../contract/contracts-services/playdex.service";
import { contractAddress } from "../contract/contract.config";

declare const analytics;

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {
    constructor(
        private web3Service: Web3Service,
        private kryptomonsService: KryptomonsService,
        private userService: UserService,
        private nftService: NFTService,
        private nftV2Service: NFTv2Service,
        private userItemsService: UserItemsService,
        private tokenService: TokenService,
        private stakingRewardService: StakingRewardsService,
        private playdexService: PlaydexService
    ) { }

    setAnalyticsForLogin(response: ISignInResponse) {
        let networkName = this.web3Service.getNetworkName();
        forkJoin([
            this.kryptomonsService.getAll(response.walletAddress),
            of(null),
            // this.nftService.ownedKryptomons(response.walletAddress),
            this.nftV2Service.ownedKryptomons(response.walletAddress),
            this.userItemsService.getLootboxItems(response.walletAddress),
            this.userService.getReferralCode(response.walletAddress),
            this.userItemsService.getNftItems(response.walletAddress),
            this.tokenService.KMONbalance(response.walletAddress),
            this.web3Service.getBalanceBnB(response.walletAddress),
            this.stakingRewardService.earned(response.walletAddress),
            of(null)
            // this.playdexService.getLenderOffersNumber(contractAddress[networkName].KMONFTV2, response.walletAddress)
        ]).subscribe(
            res => {
                let loyaltyBudget = 0;
                if (res[4].referrals != undefined && res[4].referrals.length) {
                    loyaltyBudget = res[4].loyalty.programs.kryptomon_loyalty_prod.ledger.currentBalance;
                }
                // let allItems = res[5].concat(res[3]);
                let lootboxArray = res[3].filter(item => item.type != 'UNFREEZE_POTION');
                let unfreezeAmount = res[3].filter(item => item.type == 'UNFREEZE_POTION').length;

                let nftItems: { type: string, amount: number }[] = res[5].map(item => {
                    return {
                        type: item.metadata.name,
                        amount: item.balance
                    }
                });
                //???
                nftItems = nftItems.reduce((sum, val) => {
                    for (let i in sum) {
                        if (sum[i].type === val.type) {
                            sum[i].amount++;
                            return sum;
                        }
                    }
                    sum.push(val);
                    return sum;
                }, []);
                //???
                let hasTrainerClub = res[5].filter(item => item.metadata.name == "trainers-club-badge").length > 0 ? true : false;

                // let totalKryptomonV1: number = res[1].length;
                let totalKryptomonV2: number = res[2].length;
                let totalKryptomon: number = /* totalKryptomonV1 +  */totalKryptomonV2;
                // let NFTid = res[1].concat(res[2]);
                let NFTid = res[2];
                let starter = res[0].filter(item => item.isStarter == true);
                let startersId: string[] = starter.map(item => item.tokenId);
                let startersAmount: number = startersId.length;
                let trainingSumStarter = getTrainingSum(starter);

                let rented = res[0].filter(item => item.rental == true);
                let rentedId: string[] = rented.map(item => item.tokenId);
                let rentedAmount: number = rentedId.length;
                let trainingSumRented = getTrainingSum(starter);

                let nft = res[0].filter(item => item.isStarter == false && item.rental == false);
                let trainingSumNFT = getTrainingSum(nft);
                let auraAmount = res[0].filter(item => item.extraData.unfreezable == '1').length;
                let amountFrozen = res[0].filter(item => item.gameMetadata.isFreezed).length;
                let amountAlive = res[0].filter(item => item.extraData.unfreezable != '1' && !item.gameMetadata.isFreezed).length;


                let balance = res[6];
                let balanceBnb = res[7];
                let ticketEarned = res[8];

                let ticketsAvailable = Math.round(parseFloat(this.web3Service.getWeb3().utils.fromWei(ticketEarned)) * 100) / 100;
                let kmonBalanceFull = Math.round(parseFloat(this.web3Service.getWeb3().utils.fromWei(balance)) * 100) / 100;
                let bnbBalance = Math.round(parseFloat(this.web3Service.getWeb3().utils.fromWei(balanceBnb)) * 100) / 100;
                if (res[0].length > 0 /* ||skip ==true */) {
                    analytics.identify(response.walletAddress, {
                        KryptomonNFTs: totalKryptomon,
                        KryptomonNFTsList: NFTid,
                        // KryptomonNFTsV1: totalKryptomonV1,
                        KryptomonNFTsV2: totalKryptomonV2,
                        KryptomonRented: rentedAmount,
                        KryptomonRentedList: rentedId,
                        KryptomonStarter: startersAmount,
                        KryptomonStarterList: startersId,
                        Lootboxes: lootboxArray,
                        UnfreezePotions: unfreezeAmount,
                        nftItems: nftItems,
                        auraKryptomons: auraAmount,
                        frozenKryptomons: amountFrozen,
                        aliveKryptomons: amountAlive,
                        AVGTrainingNFT: Math.round(trainingSumNFT / totalKryptomonV2),
                        AVGTrainingRented: Math.round(trainingSumRented / rentedAmount),
                        AVGTrainingStarters: Math.round(trainingSumStarter / startersAmount),
                        KMON: kmonBalanceFull,
                        BNB: bnbBalance,
                        Candies: ticketsAvailable,
                        loyaltyPoints: loyaltyBudget,
                        TrainerclubBadge: hasTrainerClub,
                        PlayfabId: response.playfabId,
                        email: response.email,
                        // referrer: this.refCode,
                        section: 'trainerHub',
                        walletProvider: response.walletProvider,
                        ethAddress: response.walletAddress
                    });

                    analytics.track('Login trainerHub', {
                        KryptomonNFTs: totalKryptomon,
                        KryptomonNFTsList: NFTid,
                        // KryptomonNFTsV1: totalKryptomonV1,
                        KryptomonNFTsV2: totalKryptomonV2,
                        KryptomonRented: rentedAmount,
                        KryptomonRentedList: rentedId,
                        KryptomonStarter: startersAmount,
                        KryptomonStarterList: startersId,
                        Lootboxes: lootboxArray,
                        UnfreezePotions: unfreezeAmount,
                        nftItems: nftItems,
                        auraKryptomons: auraAmount,
                        frozenKryptomons: amountFrozen,
                        aliveKryptomons: amountAlive,
                        AVGTrainingNFT: Math.round(trainingSumNFT / totalKryptomonV2),
                        AVGTrainingRented: Math.round(trainingSumRented / rentedAmount),
                        AVGTrainingStarters: Math.round(trainingSumStarter / startersAmount),
                        KMON: kmonBalanceFull,
                        BNB: bnbBalance,
                        Candies: ticketsAvailable,
                        loyaltyPoints: loyaltyBudget,
                        TrainerclubBadge: hasTrainerClub,
                        PlayfabId: response.playfabId,
                        email: response.email,
                        // referrer: this.refCode,
                        section: 'trainerHub',
                        walletProvider: response.walletProvider,
                        ethAddress: response.walletAddress
                    });
                } else {/* 
                    // let listedBalance = res[9]
                    // let listedPromises = Array.from({ length: parseInt(listedBalance) }, async (_, i) => {
                    //     return this.playdexService.getTokenOfLenderByIndex(contractAddress[networkName].KMONFTV2, response.walletAddress, i)
                    // })
                    // let listedTokenIds = Promise.all(listedPromises)

                    listedTokenIds.then((item) => {
                        analytics.identify(response.walletAddress, {
                            KryptomonNFTs: totalKryptomon,
                            KryptomonNFTsList: NFTid,
                            // KryptomonNFTsV1: totalKryptomonV1,
                            KryptomonNFTsV2: totalKryptomonV2,
                            KryptomonRented: rentedAmount,
                            KryptomonRentedList: rentedId,
                            KryptomonStarter: startersAmount,
                            KryptomonStarterList: startersId,
                            Lootboxes: lootboxArray,
                            UnfreezePotions: unfreezeAmount,
                            nftItems: nftItems,
                            auraKryptomons: auraAmount,
                            frozenKryptomons: amountFrozen,
                            aliveKryptomons: amountAlive,
                            AVGTrainingNFT: Math.round(trainingSumNFT / totalKryptomonV2),
                            AVGTrainingRented: Math.round(trainingSumRented / rentedAmount),
                            AVGTrainingStarters: Math.round(trainingSumStarter / startersAmount),
                            KMON: kmonBalanceFull,
                            BNB: bnbBalance,
                            Candies: ticketsAvailable,
                            loyaltyPoints: loyaltyBudget,
                            TrainerclubBadge: hasTrainerClub,
                            PlayfabId: response.playfabId,
                            email: response.email,
                            // referrer: this.refCode,
                            section: 'trainerHub',
                            walletProvider: response.walletProvider,
                            ethAddress: response.walletAddress
                        });
                    });

                    analytics.track('Login trainerHub', {
                        KryptomonNFTs: totalKryptomon,
                        KryptomonNFTsList: NFTid,
                        // KryptomonNFTsV1: totalKryptomonV1,
                        KryptomonNFTsV2: totalKryptomonV2,
                        KryptomonRented: rentedAmount,
                        KryptomonRentedList: rentedId,
                        KryptomonStarter: startersAmount,
                        KryptomonStarterList: startersId,
                        PlayfabId: response.playfabId,
                        email: response.email,
                        // referrer: refCode,
                        section: 'trainerHub',
                        value: response.walletAddress,
                        walletProvider: response.walletProvider
                    });
                 */}
            }
        );
    }
}

const getTrainingSum = (list: any[]): number => {
    let result = 0;
    list.forEach(item => {
        result = result + Math.round((item.gameMetadata.attackLevel +
            item.gameMetadata.defenseLevel +
            item.gameMetadata.hpLevel +
            item.gameMetadata.mainFamilyTalentLevel +
            item.gameMetadata.secondaryFamilyTalentLevel)
            / 5)
    })
    return result;
}

export const setAnalyticsForSignup = (post: ICreateAccount, resCreateAccount, referralCode: string): void => {
    analytics.identify(post.walletAddress, { PlayfabId: resCreateAccount.signupPayload.data.PlayFabId, ethAddress: post.walletAddress, userName: post.username, email: post.email, referrer: referralCode });
    analytics.track('Account Created', { section: 'signIn', value: post.walletAddress, email: post.email, referrer: referralCode, PlayfabId: resCreateAccount.signupPayload.data.PlayFabId });
}

export const analyticsTrack = (key: string, value: any): void => {
    analytics.track(key, value);
}